module.exports = {
      id: "ios-small-usage",
      viewBox: "0 0 448 512",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#ios-small",
      toString: function () {
        return this.url;
      }
    }